import { useAuthStore } from '@/store/auth';
import { CONFIG_ROUTES } from '@/config/routes';

const UserTwoFactorNotEnabled: Middleware = async function (ctx) {
  const auth = useAuthStore();
  const user = await auth.account.authenticate();

  if (user) {
    const isEnabled = user.twoFactorSetup;

    if (isEnabled) {
      return { name: CONFIG_ROUTES.APP_HOME, query: { redirect: ctx.to.fullPath } };
    }
  }
}

export default UserTwoFactorNotEnabled;
